import { Suspense, useState, useEffect } from 'react'
import { StyleProvider } from '@ant-design/cssinjs'
import { IntlProvider } from 'react-intl'
import { ConfigProvider, App as AntdApp, ThemeConfig } from 'antd'
import 'dayjs/locale/zh-cn'
import routeConfig from 'route/routes'
import Loading from 'layout/Loading'
import { useServeConfigStore } from './store'
import { AppContext } from "common/AppContext"

import antdZhCN from 'antd/locale/zh_CN'
import antdUsEn from 'antd/locale/en_US'

import zhCN from 'lang/zh-CN'
import usEN from 'lang/en-US'

import no_data from './assets/no_data.png'

function App() {
  const [locale, setLocale] = useState('zh-CN');
  const [localeAntd, setLocaleAntd] = useState(antdZhCN);
  const { fetchData } = useServeConfigStore();

  useEffect(() => {
    fetchData().then(() => {})
  }, []);

  const theme: ThemeConfig = {
    components: {
      Layout: {
        headerBg: 'transparent'
      },
      Table: {
        headerBg: "#F6FAFF",
        borderColor: "#DEE6FF",
        headerBorderRadius: 0,
        headerSplitColor: "#F6FAFF"
      },
      Pagination: {
        itemActiveBg: "#E3F1FF",
        itemBg: "#EEF2FC",
        colorText: "#939393",
        margin: 0
      },
      Segmented: {
        trackBg: "rgb(245 245 245 / 30%)",
        trackPadding: "5px",
        borderRadius: 8,
        borderRadiusSM: 10,
        itemColor: "rgb(0 0 0 / 60%)",
        itemHoverColor: "#2B65FE",
        itemHoverBg: "transparent",
        itemSelectedColor: "#000",
        itemActiveBg: "transparent"
      },
      Menu: {
        itemBg: "transparent",
        itemHeight: 46,
        itemColor: "rgb(0 0 0 / 60%)",
        iconSize: 20,
        itemHoverColor: "#2B65FE",
        itemHoverBg: "transparent"
      },
      Upload:{
        colorBorder:"#3085FF",
        colorText:"#3085FF",
        lineWidth:2,
      }
    }
  };

  useEffect(() => {
    switch (locale) {
      case "zh-CN":
        setLocaleAntd(antdZhCN);
        break;
      case "en-US":
        setLocaleAntd(antdUsEn);
        break;
      default:
        setLocaleAntd(antdZhCN);
        break;
    }
  }, [locale]);


  const messages: Record<string, any> = {
    "zh-CN": zhCN,
    "en-US": usEN
  };

  const emptyInfo = () => (
    <div className="tw-mt-7">
      <img src={no_data} title="no data" alt="no data" />
      <p>{locale === "zh-CN" ? "暂无数据" : "no data"}</p>
    </div>
  );

  return (
    <AppContext.Provider value={{ locale, setLocale }} >
      <IntlProvider locale={locale} messages={messages[locale]}>
        <ConfigProvider
          locale={localeAntd}
          input={{ allowClear: true }}
          form={{ colon: false }}
          // select={{ className: 'tw-min-w-[200px]' }}
          theme={theme}
          renderEmpty={emptyInfo}
        >
          <AntdApp className="tw-size-full">
            <StyleProvider layer>
              <Suspense fallback={<Loading />}>{useRoutes(routeConfig)}</Suspense>
            </StyleProvider>
          </AntdApp>
        </ConfigProvider>
      </IntlProvider>
    </AppContext.Provider>
  )
}

export default App
